<template>
    <div class="perform-rectify">
        <div class="perform-rectify__header">
            <div>
                <span class="label">绩效层级</span>
                <el-radio-group @change="setConfig" v-model="performLevel">
                    <el-radio-button
                        v-for="item in performLevelList"
                        :key="item.value"
                        :label="item.value">
                        {{ item.label }}
                    </el-radio-button>
                </el-radio-group>
            </div>
        </div>
        <Paper class="perform-rectify">
            <MPanel
                v-if="tableShow"
                ref="tablePage"
                :config="config"
                :totalData="totalData"
                :pageTotal="pageTotal"
                :loading="loading"
                :pageID="pageID"
                :searchId="searchId"
                :initSearchInfo="initSearchInfo"
                @detail-btn="viewRectify"
                @submit-btn="submitRectify"
                @noEditReason-btn="onNoEditReason"
                @searchChange="searchChange"
                @pageChange="pageChange"
                @selectChange="handleSelect"
                @sizeChange="sizeChange">
                <div slot="table-module-btn" v-if="!$store.state.supplier">
                    <div class="icon-button">
                        <el-tooltip class="item" content="导出" placement="bottom">
                            <el-button
                                class="bigData-btn-export"
                                size="mini"
                                icon="el-icon-download"
                                :loading="exportLoading"
                                @click="handleExport"></el-button>
                        </el-tooltip>
                    </div>
                </div>
                <div  slot="page-module-btn">
                    <div v-if="!$store.state.supplier">
                        <el-button
                            type="primary"
                            class="bigData-btn-issued"
                            v-has="'/performRectify-30'"
                            @click="onIssued">
                            下发整改
                        </el-button>
                        <el-button
                            type="primary"
                            class="bigData-btn-noneed-rectification"
                            v-has="'/performRectify-20'"
                            @click="onNoNeed">
                            无需整改
                        </el-button>
                    </div>
                </div>
            </MPanel>
        </Paper>
        <Rectify ref="rectifyRef" />
        <RectificationDialog ref="rectificationDialog" @refresh="onRefresh" />
    </div>
</template>
<script>
import dayjs from 'dayjs'
import MPanel from '@/components/supplierPanel'
import Paper from '@/components/core/paper/Paper'
import { dictWithUrl } from '@/components/lots/api'
import config from './config.js'
import _ from 'lodash'
import { querySupplierTransportLamination, exportSupplierTransportLamination } from '../../../api/transportStratific.js'
import { supplierLegalPersonPerformanceList, exportLegalPersonPerformance,addSupplierLegalPersonPerformanceFile,selectNeedNotRectificationReason } from '../../../api/performManage.js'
import Rectify from './components/rectify.vue'
import RectificationDialog from './components/RectificationDialog.vue'
import bigDataLog from '@/utils/bigDataLog'
import { RECTIFY_SUBMIT, NEXT_MONTH_STATUS, PERFORMANCE_DIMENSION_TYPE } from '../constant.js'
export default {
    name: 'performRectify',
    components: { Paper, MPanel, Rectify,RectificationDialog },
    data() {
        return {
            tableShow: true,
            performLevel: this.$route.query.performanceDimension || '1',
            totalData: [],
            selectList:[],
            pageTotal: 0,
            loading: false,
            pageID: 'perform-rectify_' + PERFORMANCE_DIMENSION_TYPE.COMPANY,
            searchId: 'perform-rectify_sd_' + PERFORMANCE_DIMENSION_TYPE.COMPANY,
            pageNo: 1,
            searchTerm: {},
            pageSize: 10,
            exportLoading: false,
            dictData: {},
            rowData: {},
            initSearchInfo: { month: dayjs().subtract((dayjs().date() > 1 || this.$store.state.supplier) ? 1 : 2, 'month').startOf('month').format('YYYY-MM') },
            config: _.cloneDeep(config),
            performLevelList: [
                {label: '分公司', value: '1'},
                {label: '分公司（内外部）', value: '5'},
                {label: '经营中心', value: '6'},
                {label: '经营中心（内外部）', value: '7'},
                {label: '服务平台', value: '2'},
                {label: '服务平台（内外部）', value: '3'},
            ],
        }
    },
    computed: {
    },
    methods: {
        onRefresh(){
            this.pageNo = 1
            this.loadData()
        },
        // 下发整改
        onIssued(){
            if(this.selectList.length<1){
                const message=`请勾选数据`
                this.$message.warning(message)
                return
            }

            let params={
                type:'followUpPerson',
                selectList:this.selectList
            }
         this.$refs.rectificationDialog.open(params)
        },
        //无需整改
        onNoNeed() {
            if(this.selectList.length<1){
                const message=`请勾选数据`
                this.$message.warning(message)
                return
            }
            let params={
                type:'noNeedEdit',
                selectList:this.selectList
            }
         this.$refs.rectificationDialog.open(params)
        },
        //无需整改原因
        onNoEditReason(row) {
            const {id}=row;
            let params={
                performanceId:id
            }
            let htmlStr=''
            selectNeedNotRectificationReason(params).then(res=>{
                if (res && +res.code === 0) {
                    htmlStr=`<div style="font-size:14px;margin-bottom:30px;">${res.data}</div>`
                }
            }).finally(()=>{
                this.$alert(htmlStr, '无需整改原因', {
                        dangerouslyUseHTMLString: true,
                        showConfirmButton:false,
                        customClass:'perform-rectify-no-reason-dialog'
                    }).catch(action => {
                        // console.log('aciton',action);
                        
    
                    });
            })
   
        },
        submitRectify(row) {
            this.$refs['rectifyRef'].init(row.id, false)
        },
        viewRectify(row) {
            this.$refs['rectifyRef'].init(row.id, true)
        },
        handleSelect(val) {
            this.selectList = val
        },
        searchChange(data) {
            this.pageNo = 1
            bigDataLog.sendDetailMessageByKey('bigData-btn-search')
            this.searchTerm = data
            this.loadData()
        },
        pageChange(data) {
            this.pageNo = data
            this.loadData()
        },
        sizeChange(data) {
            this.pageSize = data
            this.loadData()
        },
        // 处理请求参数
        getParams(p) {
            const params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                ...p,
            }
            if (params.month) {
                params.month = dayjs(params.month).format('YYYY-MM')
            }
            for (const key in params) {
                if (Array.isArray(params[key])) {
                    params[key] = params[key].join(',')
                }
            }
            params.systemFlag = this.$store.state.supplier ? '3' : '4'//绩效整改页面标识入参
            params.performanceDimension = this.performLevel
            if (this.$store.state.supplier) {
                params.supplierCode = this.$store.state.supplier.supplierCode
            }
            return params
        },
        loadData() {
            const params = this.getParams(this.searchTerm)
            if (!params.month && (!params.supplierCode&&!params.supplierNameCn)) {
                return this.$message.warning('请选择考核月份')
            }
            this.loading = true
            supplierLegalPersonPerformanceList(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.pageTotal = res.data.totalCount || 0
                        res.data.list.forEach(v => {
                            v._countScoreClassName = +v.countScore >= 90 ? 'score-green' : 'score-red'
                            v._nextMonthCountScoreClassName = +v.nextMonthCountScore >= 90 ? 'score-green' : 'score-red'
                            v._nextRectificationTypeClassName =
                                v.nextRectificationType === NEXT_MONTH_STATUS.STANDARD
                                    ? 'score-green'
                                    : v.nextRectificationType === NEXT_MONTH_STATUS.UNSTANDARD
                                    ? 'score-red'
                                    : ''
                            v.targetScore = '≥90'
                            v._rectificationSendStatus = this.dictData.RECTIFICATION_SEND_STATUS[v.rectificationSendStatus] //下发状态 rectificationSendStatus 字典： RECTIFICATION_SEND_STATUS
                            
                            /**
                             * detail--查看：整改提交 = 【已提交】
                             * submit--提交：LSP && 整改提交 =【待提交】
                             */
                            let hiddenEvent = []

                            if (v.isSubmitRectificationPlan !== RECTIFY_SUBMIT.SUBMITED) {
                                hiddenEvent.push('detail')
                            }
                            if (v.rectificationSendStatus !== '3') {//3 无需整改
                                hiddenEvent.push('noEditReason')
                            }

                            if (
                                v.isSubmitRectificationPlan !== RECTIFY_SUBMIT.WAIT_SUBMIT ||
                                !this.$store.state.supplier
                            ) {
                                hiddenEvent.push('submit')
                            }
                            v.hiddenEvent = hiddenEvent
                        })
                        this.totalData = res.data.list
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
        // 导出
        handleExport() {
            this.exportLoading = true
            const params = this.getParams(this.searchTerm)
            delete params.pageNo
            delete params.pageSize
            exportLegalPersonPerformance(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success(res.data)
                    }
                })
                .finally(() => {
                    this.exportLoading = false
                })
        },
        setConfig(type, isInit) {
            this.pageID = 'perform-rectify_' + type
            this.searchId = 'perform-rectify_sd' + type
            this.config.searchList.searchTxt = config.searchList.searchTxt.filter(v => !v.visible || v.visible.indexOf(type) > -1)
            this.config.table.columns = config.table.columns.filter(v => !v.visible || v.visible.indexOf(type) > -1)
            if (this.$store.state.supplier) {
                this.config.searchList.searchTxt = this.config.searchList.searchTxt.filter(
                    v => !['整改跟进人','供应商编码', '供应商名称', '下发状态'].includes(v.name),
                )
                this.config.table.action[0].ifHas = '/lsrm' + config.table.action[0].ifHas
                this.config.table.columns = this.config.table.columns.filter(v => !['整改跟进人', '下发状态'].includes(v.label))
            }
         
            this.tableShow = false
            this.pageNo = 1
            this.$nextTick(() => {
                this.tableShow = true
                if(!isInit){
                    this.searchTerm = this.initSearchInfo = { month: dayjs().subtract((dayjs().date() > 1 || this.$store.state.supplier) ? 1 : 2, 'month').startOf('month').format('YYYY-MM') }
                }
                this.loadData()
            })
        },
    },
    mounted() {
        if (this.$route.query.month) {
            this.initSearchInfo = {
                month: this.$route.query.month,
                rectificationPlanCode: this.$route.query.rectificationPlanCode,
            }
        }
        this.searchTerm = this.initSearchInfo
        //下发状态 RECTIFICATION_SEND_STATUS
        dictWithUrl('PERFORMANCE_DIMENSION_TYPE,RECTIFICATION_SEND_STATUS').then(res => {
            if (res && +res.code === 0) {
                this.dictData = res.data
                // this.loadData()
                this.setConfig(PERFORMANCE_DIMENSION_TYPE.COMPANY, true)
            }
        })
    },
}
</script>
<style lang="less">
     .perform-rectify-no-reason-dialog{
        margin-top: -200px;
        .el-message-box__title{
            span{
                font-size: 15px;
            }
            
        }
    }
.perform-rectify {
    flex: 1;
    &__header {
        background: #fff;
        margin: 10px;
        padding: 16px;
        border-radius: 4px;
        min-width: 1000px;
        .label {
            font-size: 12px;
            margin-right: 10px;
            color: #1c2631;
        }
    }

    #mPane3 {
        height: 100%;
        display: flex;
        flex-direction: column;
        .otp-table {
            flex: 1;
        }
        .el-table {
            min-height: initial;
        }
        // min-height: calc(100vh - 206px);
    }
    .score-green {
        color: green;
    }
    .score-red {
        color: red;
    }

}
</style>